import { Theme } from './types';

export const theme: Theme = {
  breakpoints: {
    small: '36em',
    medium: '48em',
    large: '62em',
    xl: '75em',
    xxl: '87em',
  },
  font: {
    family: 'Work Sans',
  },
};
